<template>
  <div @click="toNav">跳转1</div>
</template>
<script>
export default {
  created() {
     console.log(window.history,'hisotry')
  },
  mounted() {
     if (window.history && window.history.pushState) {
        // 向历史记录中插入了当前页
    
        window.addEventListener('popstate', this.goBack, true);
    }
  },
  methods: {
    toNav() {
      console.log(window, 'window')
      // window.open('http://www.baidu.com','_self')
      location.replace('http://www.baidu.com')
    },
    goBack () {
      console.log('监听')
      window.history.pushState('forward', null, '#');
      window.history.forward(1);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/page/test1.vue